module.exports = __webpack_public_path__ + "media/A13.81ea4134.mp3";